import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';

export const getTransferSchedulesQuery = gql`
  query transferSchedules($breweryId: Int!, $isConsolidated: Boolean) {
    transferSchedules(breweryId: $breweryId, isConsolidated: $isConsolidated) {
      id
      name
    }
  }
`;

const TransferScheduleOptions = ({ brewery, isConsolidated = false }) => (
  <Query query={getTransferSchedulesQuery} variables={{ breweryId: brewery.id, isConsolidated }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <option>...</option>;
      }

      if (error) {
        return <option>Sorry, there was an error getting the transfer schedules</option>;
      }

      return (
        <Fragment>
          <option value="">Select a transfer schedule</option>
          {data.transferSchedules.map(transferSchedule => (
            <option key={transferSchedule.id} value={transferSchedule.id}>
              {transferSchedule.name}
            </option>
          ))}
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(TransferScheduleOptions);



// WEBPACK FOOTER //
// ./src/containers/transferScheduleOptions/transferScheduleOptions.jsx